import {
  createRequestTypes,
  makeApiActionCreator,
  START,
  SUCCESS,
  ERROR,
} from '@actions/utils';
import * as api from '../api/search';

const namespace = 'COMPANY';

export const SET_CURRENT_COMPANY = `${namespace}/SET_CURRENT_COMPANY`;

export const setCurrentCompany = payload => ({
  type: SET_CURRENT_COMPANY,
  payload,
});

export const GET_COMPANY_METADATA = `${namespace}/GET_COMPANY_METADATA`;
export const GET_COMPANY_METADATA_ERROR = `${namespace}/GET_COMPANY_METADATA_ERROR`;

export const getCompanyMetadata = payload => {
  return async dispatch => {
    try {
      dispatch({ type: GET_COMPANY_METADATA, payload });
    } catch (error) {
      dispatch({ type: GET_COMPANY_METADATA_ERROR, payload: error });
      throw error;
    }
  };
};
export const SET_COMPANY_METADATA = `${namespace}/SET_COMPANY_METADATA`;

export const GET_COMPANY_STATUS = `${namespace}/GET_COMPANY_STATUS`;

export const GET_COMPANY_STATUS_ERROR = `${namespace}/GET_COMPANY_STATUS_ERROR`;

export const getCompanyStatus = payload => {
  return async dispatch => {
    try {
      dispatch({ type: GET_COMPANY_STATUS, payload });
    } catch (error) {
      dispatch({ type: GET_COMPANY_STATUS_ERROR, payload: error });
      throw error;
    }
  };
};
export const SET_COMPANY_STATUS = `${namespace}/SET_COMPANY_STATUS`;

export const setCompanyMetadata = payload => ({
  type: SET_COMPANY_METADATA,
  payload,
});

export const GET_COMPANY_INFO_PLUS_STATUS = `${namespace}/GET_COMPANY_INFO`;
export const getCompanyInfoPlusStatus = payload => {
  return async dispatch => {
    try {
      dispatch({ type: GET_COMPANY_INFO_PLUS_STATUS, payload });
    } catch (error) {
      dispatch({ type: GET_COMPANY_INFO_ERROR, payload: error });
      throw error;
    }
  };
};

export const GET_COMPANY_INFO = `${namespace}/GET_COMPANY_INFO`;
export const GET_COMPANY_INFO_ERROR = `${namespace}/GET_COMPANY_INFO_ERROR`;

export const getCompanyInfo = payload => {
  return async dispatch => {
    try {
      dispatch({ type: GET_COMPANY_INFO, payload });
    } catch (error) {
      dispatch({ type: GET_COMPANY_INFO_ERROR, payload: error });
      throw error;
    }
  };
};
export const SET_COMPANY_INFO = `${namespace}/SET_COMPANY_INFO`;

export const setCompanyInfo = payload => ({
  type: SET_COMPANY_INFO,
  payload,
});

export const setCompanyPinned = payload => ({
  type: SET_COMPANY_METADATA,
  payload,
});

export const SEARCH_JOB_CREATE = createRequestTypes(
  `${namespace}/SEARCH_JOB_CREATE`,
);

export const createSearchJob = makeApiActionCreator(
  api.createSearchJob,
  SEARCH_JOB_CREATE[START],
  SEARCH_JOB_CREATE[SUCCESS],
  SEARCH_JOB_CREATE[ERROR],
);

export const SEARCH_JOB_DELETE = createRequestTypes(
  `${namespace}/SEARCH_JOB_DELETE`,
);

export const deleteSearchJob = makeApiActionCreator(
  api.deleteSearchJob,
  SEARCH_JOB_DELETE[START],
  SEARCH_JOB_DELETE[SUCCESS],
  SEARCH_JOB_DELETE[ERROR],
);

export const SET_CURRENT_SEARCH = `${namespace}/SET_CURRENT_SEARCH`;

export const setCurrentSearch = payload => ({
  type: SET_CURRENT_SEARCH,
  payload,
});

export const RESET_CURRENT_SEARCH = `${namespace}/RESET_CURRENT_SEARCH`;

export const resetCurrentSearch = () => ({
  type: RESET_CURRENT_SEARCH,
});

// export const SET_SELECTED_ROUTE_METADATA = `${namespace}/SET_SELECTED_ROUTE_METADATA`;

// export const setSelectedRouteMetadata = payload => ({
//   type: SET_SELECTED_ROUTE_METADATA,
//   payload,
// });

export const SET_CURRENT_LOAD = `${namespace}/SET_CURRENT_LOAD`;

export const setCurrentLoad = payload => ({
  type: SET_CURRENT_LOAD,
  payload,
});

// export const fetchTolls = payload => {
//   return async dispatch => {
//     try {
//       dispatch({ type: TOLLS_FETCH, payload });
//     } catch (error) {
//       dispatch({ type: TOLLS_FETCH_ERROR, payload: error });
//       throw error;
//     }
//   };
// };

// export const TOLLS_FETCH = `${namespace}/TOLLS_FETCH`;
// export const TOLLS_FETCH_ERROR = `${namespace}/TOLLS_FETCH_ERROR`;
// export const TOLLS_FETCH_SUCCESS = `${namespace}/TOLLS_FETCH_SUCCESS`;
